import axios, {AxiosInstance} from 'axios';

const getEndpointURL = (path: string): string =>
  `${process.env.REACT_APP_BACKEND_URL}/${path}`;

const createApi = (): AxiosInstance =>
  axios.create({
    headers: {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
    },
  });
export default createApi();

export const getAuthApi = (token: string): AxiosInstance => {
  const api = createApi();
  api.defaults.headers.common.Authorization = `Bearer ${token}`;
  return api;
};

export const LOGIN_URL = getEndpointURL('admin/auth/login');
export interface LoginResponse {
  data: {
    expiresIn: string;
    token: string;
  };
}

export const LOGIN_CHALLENGE_URL = getEndpointURL('admin/auth/challenge');

export const GOLD_RESERVE_URL = getEndpointURL(`admin/gold/reserves`);
export const LATEST_GOLD_RESERVE_URL = getEndpointURL(
  `admin/gold/reserves/latest`,
);

export const BUYBACK_URL = getEndpointURL(`admin/token/aument/buyback`);

export const PRICE_INCREASE_URL = getEndpointURL(`admin/token/aument/price`);

export const NEXT_PRICE_INCREASE_URL = getEndpointURL(
  'admin/token/aument/price/increase',
);

export const PRICE_CORRECTION_INCREASE_URL = getEndpointURL(
  `admin/price/:exchangeSlug/increase`,
);
export const PRICE_CORRECTION_DECREASE_URL = getEndpointURL(
  `admin/price/:exchangeSlug/lower`,
);

export const EXCHANGE_STATUS_URL = getEndpointURL(
  'admin/exchanges/:exchangeSlug',
);

export const OPEN_ORDERS_URL = getEndpointURL(
  'admin/exchanges/:exchangeSlug/open_orders',
);

export const ADMIN_EXCHANGES = getEndpointURL('admin/exchanges/');

export const EXCHANGE_RATE_URL = getEndpointURL(`token/exchange_rate`);

export const ADMINS_URL = getEndpointURL(`admins`);

export const BACKEND_WALLETS = getEndpointURL('admin/wallets');

export const FREE_META_TRANSACTIONS_URL = getEndpointURL(
  `metatransactions/status`,
);

export const EXCHANGES_URL = getEndpointURL('admin/exchanges');

export const PRICE_LOGS_URL = getEndpointURL('admin/price/logs');

export const BACKING_ESTIMATE_URL = getEndpointURL(
  'admin/exchanges/:exchangeSlug/estimate_backing',
);

export const EMISSION_BACKING_ESTIMATE = getEndpointURL(
  'admin/token/aument/estimate_backing',
);

export const NOTIFICATIONS_URL = getEndpointURL('admin/notifications');

export const NOTIFICATIONS_LIVE_URL = getEndpointURL(
  'admin/notifications/live',
);

export const SPECIAL_WALLETS_URL = getEndpointURL('admin/specialWallet');